import api from "./api";

export const getPageVersions = (slug) =>
  api.get(`/pages/${slug}/versions`);

export const restorePageVersion = (slug, id) =>
  api.post(`/pages/${slug}/versions/${id}/restore`);
